<script setup lang="ts">
import Hero from '@/components/Hero.vue'
</script>

<template>
  <main class="min-h-screen" itemscope itemprop="mainContentOfPage">
    <Hero />
    <router-view />
  </main>
</template>
